import type { ReactNode } from 'react'

import { useTheme } from '@emotion/react'

import * as styles from './headline-icon.styles'
import { useSize } from './size-context'

type Props = {
  children: ReactNode
  className?: string
}

export const HeadlineIcon = ({ children, className }: Props) => {
  const theme = useTheme()
  const sizeValue = useSize()

  return (
    <div
      className={className}
      css={styles.size(theme)[sizeValue]}
      data-testid="headline-icon"
    >
      {children}
    </div>
  )
}
